module.exports = __webpack_public_path__ + "static/media/user.29745e52.svg";